export class ComplexDrawObject {
    bottomFt: number;
    bottomBeforeKickpoint: boolean;
    bottomPx: number;
    bottomAfterKickpoint: boolean;
    bottomEndBeforeBoreHoleEnd: boolean;
    topFt: number;
    topBeforeKickpoint: boolean;
    topEndBeforeKickpoint: boolean;
    topPx: number;
}